const POST_EID_QUESTIONS = 'POST_EID_QUESTIONS';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const POST_EID_ANSWERS = 'POST_EID_ANSWERS';

export {
  POST_EID_QUESTIONS,
  ASYNC_FETCH_SUCCESS,
  ERR_OCCURED,
  ASYNC_FETCH,
  POST_EID_ANSWERS,
};
